import { HttpClient } from './types';

export const createAnalyticsService = (httpClient: HttpClient) => {
  const getEndpoint = (url: string): string => `/analytics${url}`;

  return {
    getConfiguration: <TConfig = any>(): Promise<TConfig[]> => {
      return httpClient.get<TConfig[]>(getEndpoint(''));
    },
  };
};

